(function (app) {
    'use strict';

    app.factory('pageServices', pageServices);

    /*@ngInject*/
    function pageServices(queryservice, $q, $rootScope){
        $rootScope.embded = {};
        return  {
            getFooterContent:getFooterContent,
            setTitle:setTitle,
            setLogoLink : setLogoLink,
            setNavBarTitle:setNavBarTitle,
            setTitles: setTitles,
            setFavicon:setFavicon,
            setNavBarLogo:setNavBarLogo,
            setEmbded: setEmbded,
            setMenu: setMenu,
            setIsCalendarDisabled: setIsCalendarDisabled,
            setNavBarShowSignIn: setNavBarShowSignIn,
            setPageSection: setPageSection
        };

        function setTitles(title, navBarTitle, favicon ){
            console.log(title, navBarTitle, favicon,'ici please');
            setTitle(title);
            setNavBarTitle(navBarTitle);
            setFavicon(favicon);
        }
        function setLogoLink(logoLink){
          $rootScope.logoLink = logoLink;
        }
        function setPageSection(pageSection){
            console.log(pageSection,'ici please');
            $rootScope.pageSection = pageSection;
        }
        function getPageSection(){

          return  $rootScope.pageSection;
        }

        function setMenu(navBarMenu){
            console.debug('navBarMenu',navBarMenu);
            $rootScope.navBarMenu = navBarMenu;
        }

        function setNavBarLogo(navBarLogo){
            $rootScope.navBarLogo = navBarLogo;
        }
        function setTitle(title){
            $rootScope.title = title;
        }
        function setNavBarTitle(title){
           // console.log(title,'ici please');
            $rootScope.navBarTitle = title;
        }
        function setNavBarShowSignIn(navBarShowSignIn){
            $rootScope.navBarShowSignIn = navBarShowSignIn;
        }

        function setIsCalendarDisabled(isCalendarDisabled){
            $rootScope.isCalendarDisabled = isCalendarDisabled;
        }

        function setFavicon(favicon){
            $rootScope.favicon = favicon;
        }

        function setEmbded(mode){
            $rootScope.embded = $rootScope.embded || {};
            $rootScope.embded.calOnly = mode === 'calOnly';
            $rootScope.embded.noDetail = mode === 'noDetail' ||  mode === 'calOnly';
            $rootScope.embded.noHeader = mode  ? true  : false;
        }

        function getFooterContent(cId, tId) {
            if(cId){
                var args = {cId : cId, tId:tId};
                var fctName= "obtAdvHelper.getFooterInfo";
                return queryservice.callServer(fctName,args);
            }else{
                return $q.when({});
            }
        }
    }
})(angular.module('app.data'));



/*****************
 ** WEBPACK FOOTER
 ** ./app/data/page.services.js
 ** module id = 168
 ** module chunks = 0
 **/